// eslint-disable-next-line simple-import-sort/imports
import { useNavigate } from "react-router-dom";
import "./index.css";
import BackArrowIcon from "@/shared-components/icons/components/public/BackArrowIcon";
import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import update from 'immutability-helper';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Carousel from "./Carousel";
import useCache from "@/hooks/useCache";
import { useEffect, useState } from "react";
import config from "@/config";
import useStateHandler from "@/hooks/useStateHandler";
import SearchTypeService from "@/services/searchtype.service";

export default function HomeCustomization() {
  const navigate = useNavigate();
  const [changesMade, setChangesMade] = useState(false);
  const { cacheHandler } = useStateHandler();
  
  const { fetchData, refetch } = useCache(
    `search-types`,
    `${config.apis.api.url}/searchtypes`,
    {
      type: "@cache/dynamic",
      injectToken: true,
    }
  );
  const [items, setItems] = useState([]);

  const moveItem = (dragIndex, hoverIndex) => {
    setItems((prevCards) =>
      update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex]],
        ],
      }),
    );
  };
  useEffect(() => {
    if(!fetchData || !items.length) return;
    let match = fetchData.data.every((v, id) => v.title === items[id].title);
    setChangesMade(!match);
  }, [items, fetchData]);

  useEffect(() => {
    cacheHandler.storeInCache('internalcollections', fetchData);
    if(fetchData) setItems(fetchData.data);
  }, [fetchData]);

  const onClickBack = () => {
    navigate(-1);
  };

  const onCustomizeSearchType = (item) => {
    if(['price', 'size'].indexOf(item.type_id) !== -1) {
      alert("Nothing to modify in this search type");
      return;
    }
    navigate(`/admin/customize-search-type/${item.type_id}`);
  };

  const handleSaveChanges = async () => {
    setChangesMade(false);

    let match = fetchData.data.every((v, id) => v.type_id === items[id].type_id);
    if(!match) {
      let idx, i, changed = [];
      for(idx = items.length - 1; idx >= 0; idx --) {
        if(items[idx].type_id !== fetchData.data[idx].type_id)
          break;
      }
      for(i = 0; i <= idx; i ++)
        changed.push(items[i].type_id);

      await SearchTypeService.updateSearchTypesOrder(changed);
      refetch();
    }
  };

  return (
    <div className="search-customization__container">
      <div className="search-customization__header">
        <div className="search-customization__header-back">
          <BackArrowIcon onClick={onClickBack} />
        </div>
        <h4 className="search-customization__header-text">Home</h4>
        <div className="search-customization__header-logout">
          <ContinueButton turnOff={!changesMade} onClick={() => handleSaveChanges()}>Save changes</ContinueButton>
        </div>
      </div>
      <div className="search-customization__box">
        <DndProvider backend={HTML5Backend}>
          { items.map((item, idx) => 
            <Carousel
              key={item.type_id}
              data={item} 
              index={idx}
              id={item.type_id}
              onClick={() => onCustomizeSearchType(item)} 
              moveItem={moveItem} 
            />
          ) }
        </DndProvider>  
      </div>
    </div>
  );
}
